import {environment} from '../../../environments/environment';

export class BaseHttpApiService {
    protected apiURL: string;

    constructor() {
        this.apiURL = environment.apiUrl.endsWith("/") == true ? environment.apiUrl : environment.apiUrl + "/";
    }
}